type CreateEventError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  listNotFound: boolean;
};

const createEventError: CreateEventError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  listNotFound: false,
};

export type { CreateEventError };

export { createEventError };
